import { Navigate, useLocation } from "react-router-dom";

import { useAuthStore } from "@/lib/auth/store";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const access = useAuthStore((s) => s.access);
  const location = useLocation();

  if (!access) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
